import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';
import useKeepitalRoutes from '../_hook/useKeepitalRoutes';
import { INameSubSchema } from '../../../graphql/type/subSchema/name';

interface IProps {
  user: {
    _id: string;
    profile?: {
      name?: INameSubSchema;
    };
  };
  typography?: boolean;
  useAdminLink?: boolean;
  useIndexLink?: boolean;
  typographyVariant?: Variant;
}

export default function SchemaUserName(props: IProps) {
  const {
    user,
    useAdminLink,
    useIndexLink,
    typography,
    typographyVariant,
  } = props;
  const { profile } = user;
  const { path: keepitalPath } = useKeepitalRoutes();

  let text = '';
  if (profile && profile.name && profile.name.firstname)
    text += `${profile.name.firstname} `;
  if (profile && profile.name && profile.name.lastname)
    text += profile.name.lastname;

  if (!typography && (useAdminLink || useIndexLink) && user._id) {
    return (
      <Button
        disableFocusRipple
        disableElevation
        href={
          useAdminLink
            ? keepitalPath('user.dashboard', {
                userID: user._id as string,
              })
            : keepitalPath('user.index', {
                userID: user._id as string,
              })
        }
        color="primary"
        target="_blank"
      >
        {text}
      </Button>
    );
  }

  if (typography) {
    return (
      <Typography
        variant={typographyVariant || 'body2'}
        display="inline"
        component="a"
        color="primary"
        style={{ textDecoration: 'none' }}
        target="_blank"
        href={
          useAdminLink
            ? keepitalPath('user.dashboard', {
                userID: user._id as string,
              })
            : keepitalPath('user.index', {
                userID: user._id as string,
              })
        }
      >
        {text}
      </Typography>
    );
  }

  return <>{text}</>;
}
